module.exports = __webpack_public_path__ + "img/head.fa96c402.png";